var React = require('react');

function Lll (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 315V.2C.6.1 1.2 0 1.8 0h148.8c.6 0 1.3.1 1.9.1V315H0zM22.6 44.2v225.3h111.3V218H73.8V44.2H22.6zm445.1 270.7H315.3V.1h152.4v314.8zm-130-270.7v225.3h111.2v-51.4h-57.6c-2.5 0-2.5 0-2.5-2.6V44.2h-51.1z","fill":"#242d38","key":0}),React.createElement("path",{"d":"M309.9.3v314.4H157.8V.3h152.1zM291.5 218c-1 0-1.9-.1-2.8-.1h-54.4c-3.3 0-2.9.1-2.9-2.8V46.6c0-2.6 0-2.6-2.7-2.6h-46.6c-2.4 0-2.4 0-2.4 2.4v220.9c0 2.5 0 2.5 2.5 2.5H289c.8 0 1.5-.1 2.4-.1.1-17.4.1-34.4.1-51.7z","fill":"#971e23","key":1})]);
}

Lll.defaultProps = {"viewBox":"0 0 467.7 315"};

module.exports = Lll;

Lll.default = Lll;
